import constants from "../constants";

export const getBrowserNavigatorLanguage = () => {
  let language = navigator.language.toLowerCase().split(/[_-]+/)[0] || "en";
  // Save in storage for future using
  localStorage.setItem(constants.LOCAL_STORAGE.KEYS.LOCALE, language);

  return language;
};
